/**
 * Native SDK Utility Methods
 */
export const getRivenNativeSdk = () => {
  if (typeof rivenNativeSdk !== 'undefined') {
    return rivenNativeSdk;
  }
};

export const isNativeWebview = () => {
  const platform = getRivenNativeSdk()?.platform ?? '';

  return ['ios', 'android'].includes(platform);
};
